<template>
    <v-container class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary warning--text py-2" style="word-break: normal">REPORTE DE ASISTENCIA</v-card-title>
                    <v-btn bottom color="warning primary--text" depressed fab absolute right small @click="getReport(1)">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md="12">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details/>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading"
                                  :no-data-text="noDataText" :footer-props="footerProps">
                        <template v-slot:item.id="{ item }">
                            <strong>{{ (item.id).toString().padStart(5, 0) }}</strong>
                        </template>
                        <template v-slot:item.name="{ item }">
                            <span style="text-transform: capitalize">{{ (item.name).toLowerCase() }}</span>
                        </template>
                        <template v-slot:item.open="{ item }">
                            <span>{{ item.open | moment("DD/MM/YYYY HH:mm:ss") }}</span>
                        </template>
                        <template v-slot:item.open_ip="{ item }">
                            <span>{{ item.open_ip }}</span>
                        </template>
                        <template v-slot:item.close="{ item }">
                            <span>{{ item.close | moment("DD/MM/YYYY HH:mm:ss") }}</span>
                        </template>
                        <template v-slot:item.close_ip="{ item }">
                            <span>{{ item.close_ip }}</span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from '../../../helpers/form';

export default {
    name: "Attendance",
    mixins: [ Form ],
    props: [ 'user' ],
    data: () => ({
        search: '',
        headers: [
            { text: 'ID', value: 'id', sortable: false },
            { text: 'Nombre', value: 'name', sortable: false },
            { text: 'Ingreso', value: 'open', sortable: false },
            { text: 'IP Ingreso', value: 'open_ip', sortable: false },
            { text: 'Salida', value: 'close', sortable: false },
            { text: 'IP Salida', value: 'close_ip', sortable: false },
            { text: 'Tiempo', value: 'difference', sortable: false }
        ],
        desserts: [],
        loading: true,
        noDataText: 'No existen asistencias registradas',
        footerProps: {
            itemsPerPageOptions: [50, 100, 250, 500, -1]
        }
    }),
    mounted () {
        this.getReport();
    },
    methods: {
        getReport(v) {
            clearTimeout(this.timeout);
            this.loading = true;
            if (v === 1) { this.desserts = []; }
            axios.get('/api/reports/attendance').then((res) => {
                this.desserts = res.data.items;
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    this.handleErrors(err.response.data.errors);
                }
            }).then(() => {
                this.loading = false;
            });
            this.timeout = setTimeout(this.getReport, 120000);
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
